import React, { Component, Fragment } from 'react';
import ReactTable from 'react-table';
import Modal from 'react-modal'
import NotificationSystem from 'react-notification-system';
import Package from './package';
import {BeatLoader} from 'react-spinners'
import PropTypes from "prop-types";
import moment from  'moment';
import {currency_symbol} from '../../../../server/constants'
import {_addNotification, _addNotificationError, convertTwoDecimalPoint} from '../../../../server/util';
import {get, postWithHeaders,postWithHeadersResponse,patch, putWithHeadersResponse} from "../../../../server/actions";
const modalStyles = {
    content: {
        top: '40%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '40%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial'
    }
};
const notifiModalStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)',
        overflow: 'initial',
        WebkitBoxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)',
        boxShadow: '0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15)'
    }
};
const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};
const packageObj={
    action:'NEW',
    packageName: '',
    frequency: '',
    type :'',
    perAdditionalStdDiscountPerc:'',
    maxFeePerParent:'',
    price: '',
    active:true
}
class ManagePackage extends Component {
    constructor(props){
        super(props);
        this.state={
            loading: false,
            modalIsOpen: false,
            packageList:[],
            hideEnrolment:false,
            package:{...packageObj},
            conformModalIsOpen: false,
            deleteRec:{},
            notification:{
                modelIsOpen:false,
                noOfDays:'',
                lastRunOn:undefined
            }

        }
    }
    closeNotification=()=>{
        const _notification=this.state.notification;
        _notification.modelIsOpen=false;
        _notification.noOfDays='';
        _notification.lastRunOn=undefined;
        this.setState({notification:_notification})
    }
    onOpenNotificationSettings=()=>{
        this.setState({loading: true});
       const url=`/pkgNoifSetting?mealSchoolId=${sessionStorage.getItem('SchoolId')}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`;
        get(url)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            const _notification=this.state.notification;
            _notification.noOfDays=data.response.duePkgNotificationDays;
            _notification.lastRunOn=data.response.pkgDueNotificationLastRun;
            _notification.modelIsOpen=true;            
            this.setState({ notification:_notification, loading: false })
        })
        .catch(
            (error) => {
                const _notification=this.state.notification;
                _notification.noOfDays='';
                _notification.lastRunOn=undefined;
                _notification.modelIsOpen=true;            
                this.setState({ notification:_notification, loading: false })
            }
        )
    }
    onSubmitNotificationSettings=()=>{
        this.setState({loading: true});
        let headers = {
            'Content-Type': 'application/json'
        };
       const url=`/pkgNoifSetting?days=${this.state.notification.noOfDays}&mealSchoolId=${sessionStorage.getItem('SchoolId')}&schoolYear=${sessionStorage.getItem('schoolYearValue')}&access_token=`;
        putWithHeadersResponse(url,undefined,headers)
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            const _notification=this.state.notification;
            _notification.noOfDays='';
            _notification.modelIsOpen=false;            
            this.setState({ notification:_notification, loading: false })
            _addNotification(data.statusMessage, this);
        })
        .catch(
            (error) => {
                _addNotificationError(error.message, this);
                const _notification=this.state.notification;
                _notification.noOfDays='';
                _notification.modelIsOpen=false;            
                this.setState({ notification:_notification, loading: false })
            }
        )
    }
    componentWillMount=()=>{
        this.getPackageList();
    }
    componentDidMount(){
        this._notificationSystem = this.refs.notificationSystem;
    }
    onOpenPackageModel=()=>{
        this.setState({modalIsOpen:true});
    }
    onClosePackageModel=()=>{
        this.setState({modalIsOpen:false,package:{...packageObj}});
    }
    getPackageList=()=>{
        this.setState({loading: true});
        get('/schoolPackages/search/findByMealSchoolSchoolIdAndSchoolYearAndIsActive?mealSchoolId='+sessionStorage.getItem('SchoolId')+'&schoolYear='+sessionStorage.getItem('schoolYearValue')+'&isActive=true&access_token=')
        .then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            const list=((data||{})._embedded||{}).schoolPackages||[];
            
            this.setState({ 
                packageList:list,
                hideEnrolment:list.some(item=>{
                return item.type=="Enrollment"
            }),
            loading: false});
        })
        .catch(
            (error) => {
                console.log('Get orderlist response', error)
                this.setState({ packageList:[], loading: false})
            }
        )
    }
    deactivatePackage=()=>{
        const data=this.state.deleteRec
        this.setState({loading: true})
        const headers = {
            'Content-Type': 'application/json'
        };
        const recId=data._links.self.href.split('/').pop();
        const reqObj= {
            "active": false,
            "loggedUser":  JSON.parse(sessionStorage.getItem('loggedInUserInfo')).username
          }
        patch('/schoolPackages/'+recId+'?access_token=', JSON.stringify(reqObj),headers).then((response) => {
            /* if (!response.ok) {               
                throw Error(response.statusMessage);
            }
            console.log('response', response); */
            return response;
        }).then(res => {
            this.setState({loading: false, conformModalIsOpen:false})
            _addNotification('Record deleted successfully', this);
            this.onClosePackageModel();
            this.getPackageList();
        }).catch(
            (error) => {
                this.setState({loading: false})
                _addNotificationError(error.message,this);
            }
        )
    }
    savePackage=(data)=>{
        this.setState({loading: true})
        const headers = {
            'Content-Type': 'application/json'
        };
        const reqObj={
            "active": data.active,
            "frequency": data.frequency,
            "loggedUser": JSON.parse(sessionStorage.getItem('loggedInUserInfo')).username,
            "mealSchool": `/mealManage/mealSchools/${sessionStorage.getItem('SchoolId')}`,
            "packageName": data.packageName,
            "price": data.price,
            "type":data.type,
	        "perAdditionalStdDiscountPerc":parseFloat(convertTwoDecimalPoint(data.perAdditionalStdDiscountPerc,2)),
            "maxFeePerParent":parseFloat(convertTwoDecimalPoint(data.maxFeePerParent,2)),
            "schoolYear": sessionStorage.getItem('schoolYearValue')
          }
        if(data.action==='EDIT'){
            const recId=data._links.self.href.split('/').pop();
            patch('/schoolPackages/'+recId+'?access_token=', JSON.stringify(reqObj),headers).then((response) => {
                /* if (!response.ok) {               
                    throw Error(response.statusMessage);
                }
                console.log('response', response); */
                return response;
            }).then(res => {
                this.setState({loading: false})
                _addNotification('Record updated successfully', this);
                this.onClosePackageModel();
                this.getPackageList();
            }).catch(
                (error) => {
                    this.setState({loading: false})
                    _addNotificationError(error.message,this);
                }
            )
        }else{
            postWithHeadersResponse('/schoolPackages?access_token=', JSON.stringify(reqObj),headers).then((response) => {
                /* if (!response.ok) {               
                    throw Error(response.statusMessage);
                }
                console.log('response', response); */
                return response;
            }).then(res => {
                this.setState({loading: false})
                _addNotification('Record inserted successfully', this);
                this.onClosePackageModel();
                this.getPackageList();
            }).catch(
                (error) => {
                    this.setState({loading: false})
                    _addNotificationError(error.message,this);
                }
            )
        }        
    }
    getEnrolmentHideStatus=()=>{
        if(this.state.hideEnrolment && this.state.package.action!=='EDIT'){
            return true;
        }else if(this.state.hideEnrolment && this.state.package.action=='EDIT' && this.state.package.type!=="Enrollment"){
            return true
        }
        return false;
    }
    render() {
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem"/>
                    <section className=" full-width clearfix">
                        <div className='sweet-loading'
                            style={{position: 'fixed', top: '50%', left: '48%', zIndex: '1000'}}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="sectionTitle">
                                    <h2>
                                        <span>Manage Before & After Care Package</span>
                                        <div style={{display:'inline-block',marginLeft: '50px'}}>
                                        
                                        </div>
                                    </h2>
                                </div>
                            </div>
                            <div className="clearfix"></div>                            
                            <div className="row">                        
                                <div className="panel panel-primary">      
                                    <div className="col-md-12">
                                        <div className="pull-right button-group-section">
                                        <button className="btn btn-xs btn-warning" style={{margin:'0px 8px'}} onClick={()=>{
                                            this.onOpenNotificationSettings();
                                            }}>Settings</button>
                                            <button type="button" className="btn btn-success btn-xs"
                                                style={{
                                                    margin: '10px 0px 10px 5px',                                                    
                                                    fontSize: '14px',
                                                    marginTop: "10px"
                                                }} onClick={()=>{
                                                    this.onOpenPackageModel();
                                                }}>
                                                <i className="glyphicon glyphicon-ok"></i> Add Package
                                            </button>                                            
                                        </div>
                                    </div>
                                    <div className="panel-body">
                                    <ReactTable
                                        data={this.state.packageList}
                                        columns={[
                                            {
                                                Header: "Name",
                                                style: {textAlign: 'center'},
                                                accessor: "packageName"
                                            },
                                            {
                                                Header: "Type",
                                                width:200,
                                                style: {textAlign: 'center'},
                                                accessor: "type"
                                            },
                                            {
                                                Header: "Frequency",
                                                width:200,
                                                style: {textAlign: 'center'},
                                                accessor: "frequency"
                                            },{
                                                accessor: 'price', // formatted mobile num for display
                                                Header: 'Price',
                                                style: { textAlign: 'center' },
                                                Cell: ({row}) => (
                                                    <span style={{textAlign:'center'}}>
                                                    {currency_symbol()+' '+convertTwoDecimalPoint(row._original.price)} </span>)
                                            },{
                                                Header: "Action",
                                                style: {textAlign: 'center'},
                                                Cell: ({row}) => (
                                                    <Fragment>
                                                         <a title="Click to edit record" onClick={()=>{
                                                        this.setState({package:{...row._original, action:'EDIT'},modalIsOpen:true});
                                                    }}><i className="fa fa-pencil-square-o tbl-rounded-icon bg-color-5 fa-icon" /></a>
                                                    <a title="Click to delete record" onClick={()=>{
                                                        this.setState({deleteRec:row._original,conformModalIsOpen:true});
                                                    }}><i className="fa fa-trash-o tbl-rounded-icon bg-color-3 fa-icon" /></a>
                                                </Fragment>
                                                )
                                            }
                                        ]}
                                        defaultPageSize={10}
                                        className="-striped -highlight"                                       
                                    />
                                    </div>
                                    </div>
                                </div>
                            </div>
                    </section>  
                    <Modal
                        isOpen={this.state.modalIsOpen}
                        onRequestClose={() => this.setState({modalIsOpen: false})}
                        style={modalStyles}
                        contentLabel="Activation"
                        ariaHideApp={false}
                    >
                        <div className="row">
                                <div className="col-md-12">
                                    <Package 
                                    hideEnrolment={this.getEnrolmentHideStatus()} data={this.state.package}
                                    onSubmit={(e,data)=>{
                                        this.savePackage(data);                         
                                    }} 
                                    onCancel={(e)=>{
                                        this.onClosePackageModel();
                                    }} />
                                </div> 
                        </div>
                    </Modal>
                    <Modal
                        isOpen={this.state.conformModalIsOpen}
                        onRequestClose={() => this.setState({ conformModalIsOpen: false })}
                        style={deleteStyles}
                        contentLabel="Activation">
                        <div className="modal-header">
                            <h4 className="modal-title modal-title-color" id="deleteLabel">Delete Package Fee</h4>
                        </div>
                        <div className="modal-body">
                            <p>Are you sure you want to delete :<b
                                        style={{ wordBreak: 'w' }}>{this.state.deleteRec.packageName}</b>
                                    </p>
                                </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={() => this.setState({ conformModalIsOpen: false, deleteRec:{} })}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={()=>{this.deactivatePackage()}}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Delete
                                    </button>
                                </div>
                            </Modal>
                            <Modal isOpen={this.state.notification.modelIsOpen} style={notifiModalStyles}>
                    <div className="modal-header row">
                        <h4 className="modal-title modal-title-color col-md-10" id="deleteLabel">Notification Settings</h4>
                        <div className="col-md-2">
                            <button type="button" className="pull-right btn-danger" onClick={() => this.closeNotification()}>X</button></div>
                        </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xs-12 col-sm-12 col-md-12">
                                <div className="form-group">
                                    <label htmlFor="noDays">No of days before notification</label>
                                        <select className="form-control" name="payType" value={this.state.notification.noOfDays} onChange={
                                                (e)=>{
                                                    let _notification=this.state.notification;
                                                    _notification.noOfDays=e.target.value;
                                                    this.setState({notification:_notification})
                                                }
                                            } >
                                                <option value=''></option>
                                                {
                                                    [1,2,3,4,5,6,7,8,9,10].map(day=>{
                                                        return <option value={day}>{day}</option>
                                                    })
                                                }
                                            </select>                                            
                                </div>
                                <div className="form-group">
                                    <label>{`Notification last ran on : ${this.state.notification.lastRunOn?moment(this.state.notification.lastRunOn).format('YYYY-MM-DD hh:mm:ss'):'NA'}`}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-danger btn-xs"
                            onClick={() => this.closeNotification()}>
                            <i className="fa fa-times-circle"
                            style={{ margin: '0 0 0 5px' }}></i> Cancel
                        </button>
                        <button type="button" id="paySubmit" onClick={(e)=>{
                            this.onSubmitNotificationSettings(e);
                            }}
                        className="btn btn-success btn-xs">
                            <i className="fa fa-check-circle"
                            style={{ margin: '0 0 0 5px' }}></i> Submit
                        </button>
                    </div>
                </Modal>  
            </Fragment>
        )
    }
}
export default ManagePackage



// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/BcAc/ManagePackage/index.jsx